import React, { useEffect, useState } from 'react';

import {
  Button,
  Card,
  Table,
  Row,
  Col,
  Space,
  message,
  Form,
  Switch,
  Flex,
  Typography,
} from 'antd';
import _, { debounce } from 'lodash';
import { useIntl } from 'react-intl';
import IntlMessage from '../../../components/IntlMessage';
import userOperatorApi from '../../../api/user-operator';
import PageTitle from '../../../components/PageTitle';
import ActionBar from '../../../components/ActionBar';
import AddUserOperatorForm from './addUserOperatorForm';
import FilterBar from '../../../components/FilterBar';

const { Text } = Typography;
const UserSetting = () => {
  const [total, setTotal] = useState(1);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [usersOperator, setUsersOperator] = useState([]);
  const [condition, setCondition] = useState({});
  const [currentData, setCurrentData] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
    filter_name: ['is_agent'],
    filter_value: [true],
  });
  const [modal, setModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    const fetch = async () => {
      try {
        setLoading(true);
        const res = await userOperatorApi.getAllUser(filter);
        setLoading(false);
        setTotal(res.total);
        if (res) {
          setUsersOperator(res?.data);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetch();
  }, [filter, reload]);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value,
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] },
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };

  const onFilter = debounce(async (value, title, type) => {
    if (type === 'search') {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const onReload = () => {
    setReload((reload) => !reload);
  };

  const onOpenModal = () => {
    setOpenModal(true);
  };
  const onOpenEditModal = (record) => {
    setOpenModal(true);
    setCurrentData(record);
  };

  const onModalClose = () => {
    form.resetFields();
    setOpenModal(false);
    setCurrentData(null);
  };

  const intl = useIntl();

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onChangeStatus = async (isChecked, record) => {
    setLoading(true);
    await userOperatorApi.updateStatusUserAgent(record?.id, {
      status: isChecked,
    });
    setUsersOperator((data) =>
      data.map((item) => {
        if (item.id === record.id) {
          return {
            ...item,
            status: isChecked,
          };
        }
        return item;
      }),
    );
    setLoading(false);
  };

  const columns = [
    {
      title: <IntlMessage id="global.firstname" />,
      key: 'firstname',
      dataIndex: 'id',
      render: (_, record) => {
        return (
          <Button
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '3px',
              color: '#14bb8c',
            }}
            onClick={() => onOpenEditModal(record)}
            type="link">
            {record?.user?.firstname}
          </Button>
        );
      },
    },
    {
      title: <IntlMessage id="global.lastname" />,
      key: 'lastname',
      sorter: true,
      dataIndex: 'lastname',
      render: (_, record) => {
        return `${record?.user?.lastname}`;
      },
    },
    {
      title: <IntlMessage id="global.email" />,
      key: 'email',
      sorter: true,
      dataIndex: 'email',
      render: (_, record) => {
        return `${record?.user?.email}`;
      },
    },
    {
      title: <IntlMessage id="global.phone" />,
      key: 'phone',
      sorter: true,
      dataIndex: 'phone',
      render: (_, record) => {
        return (
          record?.user?.mobile && (
            <Space size={4}>
              <Text>{record?.user?.mobile}</Text>
              {/* <a href={`https://zalo.me/${record.phone}`} target="_blank">
                 <Image
                   style={{
                     width: '20px',
                   }}
                   preview={false}
                   src={zalo_icon}
                 />
               </a> */}
            </Space>
          )
        );
      },
    },
    {
      title: <IntlMessage id="global.user_id" />,
      key: 'userId',
      dataIndex: 'userId',
      render: (text, record, index) => {
        return record?.user?.id ? record?.user?.id : 'N/A';
      },
    },
  ];

  const onDelete = async (id) => {
    try {
      const res = await userOperatorApi.delete(id);
      if (res) {
        message.success('Successfully deleted user');
        onReload();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Card bordered={false} style={{ minHeight: '100%' }}>
      <Row justify="space-between">
        <Col>
          {' '}
          <PageTitle title={<IntlMessage id="global.user" />} />
        </Col>

        <Col>
          <ActionBar
            onDelete={() => onDelete(selectedRowKeys)}
            isShowAddButton={true}
            deleteMessage={
              'Warning! You are about to delete this user and its associated records. Are you sure you want to delete this record?'
            }
            onAdd={onOpenModal}
            onRefresh={() => onReload()}
            isShowPublishButtons={false}
            isShowCopyButton={false}
            isShowDeleteButton={false}
            add_new={'Nouvel agent'}
            isDisabled={!(selectedRowKeys.length > 0)}></ActionBar>
        </Col>
      </Row>

      <br />

      <Flex vertical gap={12}>
        <FilterBar
          onFilter={onFilter}
          // data={[
          //   {
          //     name: 'status',
          //     data: [
          //       { title: 'Active', value: '1' },
          //       { title: 'Inactive', value: '0' },
          //     ],
          //     placeholder: <IntlMessage id="global.status" />,
          //   },
          // ]}
        />

        <Table
          tableLayout="auto"
          scroll={{ x: 'max-content' }}
          columns={columns}
          dataSource={usersOperator}
          onChange={onChangeTable}
          rowKey="id"
          size="small"
          loading={loading}
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            total: total,
            current: filter.page,
            pageSize: filter.limit,
          }}
          rowSelection={rowSelection}
        />
      </Flex>
      {openModal ? (
        <AddUserOperatorForm
          openModal={openModal}
          onModalClose={onModalClose}
          onReload={onReload}
          currentData={currentData?.user}
          data={currentData}
          userOprator={currentData}
        />
      ) : null}
    </Card>
  );
};

export default UserSetting;
